import { AccountDeliveryAddress } from './account-delivery-address';
import { CartDetailViewModel } from './cart-item.model';
import { ApiResponse } from './api-response.model';

export const SubscriptionOrderNo = '1001';
export const SubscriptionSalesType: string[] = ['MR', 'AO', 'AY', 'IN'];

export interface FreightViewModel {
  shippingMethod: string;
  zoneID: number;
  roadFreight: number;
  airFreight: number;
  shippingInstructions: string;
  isQuoteRequired: boolean;
  isAirQuoteRequired: boolean;
  suburb: string;
  state: string;
  postcode: string;
  isPartShip: boolean;
  freeFreightPromo: string;
  country: string;
  freightCost: SHAusPostGetFreightQuoteResponse;
  freightCharge: number;
  carrierCode: string;
  carrierServiceCode: string;
}

export interface PaymentApiResponse {
  result: string;
  returnType: string;
  paywayURL: string;
  message: string;
}

export interface PaymentViewModel {
  poReference: string;
  paymentMethod: string;
  nameOnCard: string;
  totalAmount: string;
  transactionSurcharge: string;
  cartTax: string;
  isDDCreditAccount: boolean;
  isEditable: boolean;
  customerPaymentNumber: string;
}

export interface DickerTransportZonesDetail {
  id: number;
  zone: number;
  state: string;
  location: string;
  postcode: string;
  companyCode: string;
  dateAdded: Date;
}

export interface DickerSelectListItem {
  text: string;
  value: string;
  displayText: string;
  selected: boolean;
}

export interface CheckoutViewModel {
  kitProgramTypeList: string;
  firstStep: string;
  allFreightFreeProducts: string;
  showBackToCart: boolean;
  tenantDetailsRequired: string;
  programType: string;
  containsDirectShippingProducts: string;
  autoPilotRequired: string;
}

export interface CheckoutStatusModel {
  hasChosenCheckout: boolean;
  firstStep: string;
  currentStep: string;
  collectOrder: boolean;
  tenantDetailsRequired: string;
}

export interface EndUserModel {
  cartEndUser: CartEndUser;
  salesTypeTab: string[];
  endUserTemplate: string[];
  salesTypeDescription: string[];
  accountId: string;
  step: string;
}

export interface TenantViewModel {
  tenantId: string;
  partnerId: string; // MPN or CSN
  defaultOwnerUsageEmail: string;
  mpnList: string[];
  showDefaultOwnerEmail: string;
}

export interface GetCSPTenant {
  out_status: string;
  out_status_desc: string;
  out_result_status: string;
  out_tenant_id: string;
  out_company_name: string;
  out_first_name: string;
  out_last_name: string;
  out_message: string;
  out_prefix: string;
  out_address_1: string;
  out_address_2: string;
  out_address_3: string;
  out_city: string;
  out_post_code: string;
  out_region: string;
  out_country: string;
  out_phone: string;
  out_culture: string;
  out_process_datetime: string;
  out_next_billing_date: string;
  out_last_billing_date: string;
  out_user_name: string;
  out_password: string;
  out_error_message: string;
  out_email: string;
  out_customer_id: string;
  out_allow_random: string;
  out_accountcode: string;
  out_amount: string;
  out_tenant_desc: string;
  out_min_threshold: string;
  out_max_threshold: string;
  out_threshold_email: string;
  out_threshold_phone: string;
  out_tenant_type: string;
  out_related_csn: string;
  out_contains_usage: string;
  out_digital_wallet_id:string;
  // fileds for implementation
  selected: boolean;
}

export interface CreateCSPOrder {
  in_accountcode: string;
  in_stock_code: string;
  in_qty: string;
  in_parent_stock_code: string;
  in_subscription_desc: string;
  in_tenant_guid: string;
  in_mpnid: string;
  in_default_email: string;
  in_login: string;
  type: string;
  in_customer_reference: string;
}

export interface TenantResponse {
  result: string;
  info: string;
  tenantId: string;
  password: string;
}

export enum ProgramType {
  CSP,
  ADM,
  ADY
}

export interface ShippingAddress {
  cartId: string;
  fullName: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4?: string;
  suburb: string;
  state: string;
  postcode: string;
  phone: string;
  email: string;
  attnRef: string;
  collectOrder: string;
  partShip: boolean;
  dispatchDate: string;
  addressDisplay: string;
  salesTypeTab: string;
  endUserTemplate: string;
  isEditable: boolean;
  nextStep: string;
  isAu: boolean;
  attnOrRef: string;
  naType: string;
  WarehouseName :string;
}

export interface CheckoutSummaryViewModel {
  shippingAddress: ShippingAddress;
  freight: FreightViewModel;
  payment: PaymentViewModel;
  cartDetail: CartDetailViewModel[];
}

export interface OrderConfirmationViewModel {
  orderNumber: number;
  poReference: string;
  containsSubscriptionItem: boolean;
  tenantId: string;
  shippingAddress: ShippingAddress;
  cartDetail: CartDetailViewModel[];
  freight: FreightViewModel;
  payment: PaymentViewModel;
  apiResponse: ApiResponse;
}

export interface GetEndUserSalesTypeOut {
  out_message: string;
  out_result_status: string;
  out_sales_type: string;
  out_sales_type_desc: string;
}

export interface GetEndUserAddressBookOutput {
  out_user_only_18_pos: string;
  out_user_only_1_flg: string;
  out_address_3: string;
  out_user_only_5: string;
  out_address_4_prompt: string;
  out_user_only_d1: string;
  out_agree_status_desc_flg: string;
  out_first_name: string;
  out_user_only_d3_pos: string;
  out_country_pos: string;
  out_address_4_flg: string;
  out_suburb_flg: string;
  out_user_only_14: string;
  out_address_3_pos: string;
  out_postcode_pos: string;
  out_user_only_d4_flg: string;
  out_company_name_flg: string;
  out_user_only_7: string;
  out_first_name_flg: string;
  out_agreement_pos: string;
  out_user_only_9: string;
  out_agree_type_flg: string;
  out_address_2: string;
  out_user_only_d3_prompt: string;
  out_agree_status: string;
  out_fax: string;
  out_display_name_pos: string;
  out_agree_start_pos: string;
  out_address_1_pos: string;
  out_address_2_prompt: string;
  out_user_only_13_prompt: string;
  out_agree_review: string;
  out_agree_review_pos: string;
  out_fax_flg: string;
  out_user_only_13_flg: string;
  out_user_only_7_prompt: string;
  out_user_only_7_pos: string;
  out_agree_status_prompt: string;
  out_user_only_16: string;
  out_user_only_3_flg: string;
  out_user_only_6_prompt: string;
  out_agree_start_flg: string;
  out_country: string;
  out_address_1_prompt: string;
  out_user_only_d1_flg: string;
  out_address_5_pos: string;
  out_user_only_20_pos: string;
  out_user_only_d1_pos: string;
  out_user_only_20_flg: string;
  out_phone: string;
  out_agree_review_prompt: string;
  out_fax_prompt: string;
  out_user_only_4_flg: string;
  out_agree_status_desc_prompt: string;
  out_user_only_13: string;
  out_user_only_19_pos: string;
  out_last_name: string;
  out_user_only_d2: string;
  out_address_4_pos: string;
  out_state_pos: string;
  out_user_only_11: string;
  out_agree_type_pos: string;
  out_agree_status_desc: string;
  out_agreement: string;
  out_user_only_13_pos: string;
  out_last_name_pos: string;
  out_user_only_12_flg: string;
  out_user_only_20_prompt: string;
  out_user_only_d3: string;
  out_state_flg: string;
  out_user_only_14_flg: string;
  out_agree_support_prompt: string;
  out_user_only_20: string;
  out_user_only_18_prompt: string;
  out_mobile_prompt: string;
  out_address_5_flg: string;
  out_agree_review_flg: string;
  out_mobile: string;
  out_user_only_9_flg: string;
  out_company_id_prompt: string;
  out_postcode_prompt: string;
  out_address_5: string;
  out_user_only_11_pos: string;
  out_user_only_17_pos: string;
  out_user_only_10_pos: string;
  out_message: string;
  out_suburb_pos: string;
  out_agree_line_ref: string;
  out_user_only_10_prompt: string;
  out_agree_support: string;
  out_suburb: string;
  out_user_only_3: string;
  out_user_only_d4_pos: string;
  out_agree_support_pos: string;
  out_address_2_pos: string;
  out_address_3_flg: string;
  out_user_only_4_prompt: string;
  out_user_only_19: string;
  out_user_only_2_pos: string;
  out_agree_start_prompt: string;
  out_user_only_3_prompt: string;
  out_user_only_16_pos: string;
  out_agreement_flg: string;
  out_user_only_4: string;
  out_postcode: string;
  out_user_only_6: string;
  out_country_flg: string;
  out_user_only_1: string;
  out_agree_line_ref_pos: string;
  out_user_only_5_flg: string;
  out_address_5_prompt: string;
  out_user_only_15: string;
  out_user_only_d2_prompt: string;
  out_user_only_8: string;
  out_display_name: string;
  out_agree_type: string;
  out_user_only_19_flg: string;
  out_agree_start: string;
  out_user_only_17: string;
  out_fax_pos: string;
  out_email: string;
  out_agree_expire_flg: string;
  out_user_only_19_prompt: string;
  out_user_only_6_pos: string;
  out_agree_expire: string;
  out_result_status: string;
  out_user_only_d2_flg: string;
  out_display_name_prompt: string;
  out_country_prompt: string;
  out_user_only_12_pos: string;
  out_state: string;
  out_mobile_pos: string;
  out_agree_expire_prompt: string;
  out_suburb_prompt: string;
  out_address_1_flg: string;
  out_first_name_pos: string;
  out_agree_status_flg: string;
  out_user_only_1_prompt: string;
  out_user_only_d2_pos: string;
  out_user_only_8_flg: string;
  out_user_only_8_pos: string;
  out_address_1: string;
  out_user_only_18_flg: string;
  out_user_only_d4_prompt: string;
  out_user_only_10_flg: string;
  out_user_only_3_pos: string;
  out_first_name_prompt: string;
  out_address_4: string;
  out_phone_prompt: string;
  out_user_only_d3_flg: string;
  out_email_pos: string;
  out_user_only_17_flg: string;
  out_state_prompt: string;
  out_user_only_12_prompt: string;
  out_user_only_2_flg: string;
  out_agree_expire_pos: string;
  out_agree_status_pos: string;
  out_address_3_prompt: string;
  out_user_only_16_prompt: string;
  out_user_only_14_pos: string;
  out_user_only_18: string;
  out_user_only_16_flg: string;
  out_email_prompt: string;
  out_user_only_9_prompt: string;
  out_company_name: string;
  out_user_only_15_prompt: string;
  out_user_only_11_flg: string;
  out_phone_flg: string;
  out_user_only_5_prompt: string;
  out_agree_type_prompt: string;
  out_user_only_7_flg: string;
  out_mobile_flg: string;
  out_user_only_1_pos: string;
  out_company_id_pos: string;
  out_user_only_d1_prompt: string;
  out_user_only_6_flg: string;
  out_last_name_prompt: string;
  out_company_name_prompt: string;
  out_user_only_15_flg: string;
  out_postcode_flg: string;
  out_last_name_flg: string;
  out_user_only_11_prompt: string;
  out_user_only_d4: string;
  out_agree_support_flg: string;
  out_agree_status_desc_pos: string;
  out_eu_id: string;
  out_user_only_12: string;
  out_user_only_5_pos: string;
  out_phone_pos: string;
  out_agree_line_ref_flg: string;
  out_agree_line_ref_prompt: string;
  out_user_only_2_prompt: string;
  out_company_id_flg: string;
  out_agreement_prompt: string;
  out_address_2_flg: string;
  out_user_only_17_prompt: string;
  out_user_only_2: string;
  out_email_flg: string;
  out_user_only_4_pos: string;
  out_user_only_9_pos: string;
  out_sales_type: string;
  out_user_only_15_pos: string;
  out_company_name_pos: string;
  out_user_only_10: string;
  out_user_only_8_prompt: string;
  out_user_only_14_prompt: string;
  out_display_name_flg: string;
  out_company_id: string;
  out_sales_type_desc: string;
}

export interface SHAusPostGetFreightQuoteResponse {
  carriers: Carrier[];
  warnings: Array<string>;
}

export interface Carrier {
  serviceCode: string;
  serviceName: string;
  serviceDescription: string;
  calculated_Price: number;
  calculated_Price_Ex_GST: number;
  calculated_GST: number;
  error: string;
  warning: string;
  carrierCode:string;
  carrierServiceCode:string;
}

export interface CartBillingAndShippings {
  airTerms: string;
  willBeCollected: string;
  shippingInstructions: string;
  freightCharge: number;
  freightMethod: string;
}

export interface CartEndUser {
  cartId: number;
  salesType: string;
  outFirstName: string;
  outLastName: string;
  outDisplayName: string;
  outCompanyName: string;
  outCompanyId: string;
  outAddress1: string;
  outAddress2: string;
  outAddress3: string;
  outAddress4: string;
  outAddress5: string;
  outSuburb: string;
  outState: string;
  outCountry: string;
  outPostcode: string;
  outPhone: string;
  outFax: string;
  outEmail: string;
  outMobile: string;
  outAgreement: string;
  outAgreeStart: string;
  outAgreeExpire: string;
  outAgreeReview: string;
  outAgreeVersion: string;
  outAgreeSupport: string;
  outAgreeType: string;
  outAgreeStatus: string;
  outAgreeStatusDesc: string;
  outAgreeLineRef: string;
  outUserOnly1: string;
  outUserOnly2: string;
  outUserOnly3: string;
  outUserOnly4: string;
  outUserOnly5: string;
  outUserOnly6: string;
  outUserOnly7: string;
  outUserOnly8: string;
  outUserOnly9: string;
  outUserOnly10: string;
  outUserOnly11: string;
  outUserOnly12: string;
  outUserOnly13: string;
  outUserOnly14: string;
  outUserOnly15: string;
  outUserOnly16: string;
  outUserOnly17: string;
  outUserOnly18: string;
  outUserOnly19: string;
  outUserOnly20: string;
  outUserOnlyD1: string;
  outUserOnlyD2: string;
  outUserOnlyD3: string;
  outUserOnlyD4: string;
}

export interface CirrusTenantResponse {
  tenantId: string;
  subscriptionId: string;
  firstName: string;
  lastName: string;
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressLine4?: string;
  suburb: string;
  state: string;
  postcode: string;
  phone: string;
  email: string;
  attnRef: string;
  status: string;
  resultStatus: string;
  message: string;
  }

  export interface CirrusCancelSubscriptionResponse {
    code: string;
    detail: string;
    resultStatus: string;
    message: string;
  }